module.exports = __webpack_public_path__ + "static/media/nav-attribute-dependency.22bc22b3.svg";